module.exports = __webpack_public_path__ + "img/laos.38185ab9.svg";